import Link from "next/link";
import { ArrowRight } from "lucide-react";

import Magnetic from "@/components/motion/Magnetic";

type SectionActionLinkProps = {
  href: string;
  children: React.ReactNode;
};

export default function SectionActionLink({ href, children }: SectionActionLinkProps) {
  return (
    <Magnetic>
      <Link
        href={href}
        className="group hover:text-muted-foreground flex items-center gap-2 text-sm font-bold tracking-wider uppercase transition-colors md:text-lg"
      >
        {children}
        <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1 md:h-5 md:w-5" />
      </Link>
    </Magnetic>
  );
}
